import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import axios from 'axios';
import {config} from '../../common/config/config';
import {
    constance,
    WorkplaceInterface,
} from '../../common/constance/constance';
import {common} from '../../common/common';
import {styles} from '../../common/style';
import {useNavigate} from 'react-router-dom';
import PostEditor from './editor/PostEditor';
import TextField from '@mui/material/TextField';
import {PostInterface} from '../../interface/post.interface';
import {MenuInterface} from "../../interface/menu.interface";
import {FormControl, FormControlLabel, Radio, RadioGroup} from "@mui/material";
import ReactQuill from "react-quill";
import SelectDepartmentComponent from "./selectOption/SelectDepartmentComponent";
import {Club} from "../../interface/club.interface";
import {Department} from "../../interface/department.interface";
import {initClub, initDepartment} from "../../common/initState";
import SelectClubComponent from "./selectOption/SelectClubComponent";
import FileUpload from "./fileUpload/FileUpload";
import FileUpdate from "./fileUpload/FileUpdate";
import ShareBoardInputComponent from "./shareInputs/ShareBoardInputComponent";
import FleaMarketBoardInputComponent from "./shareInputs/FleaMarketBoardInputComponent";


export default function PostUpdate() {
    console.log('PostUpdate');
    const [state, setState] = useState<PostInterface>({
        _id: '', contents: '', createdAt: null, id: '', no: 0, title: '', usage: '', isBlockView: false, hitCount: 0,
        club: {_id: "", createdAt: new Date(), kind: "", name: "", usage: 'Y', workplace: ""},
        department: {
            _id: "",
            departmentCode: "",
            workplace: "",
            departmentName: ""
        },
        comment: {
            _id: "",
            content: "",
            createdAt: null,
            depth: 0,
            post: undefined,
            sorts: 0,
            targetWriter: {_id: "", admin: false, departmentCode: "", departmentName: "", id: "", name: ""},
            usage: "",
            user: {_id: "", admin: false, departmentCode: "", departmentName: "", id: "", name: ""}
        },
        user: {
            _id: '',
            admin: false,
            departmentCode: '',
            departmentName: '',
            id: '',
            name: '',
        },
        workplace: '',
        amount: 1, replyCount: 0,
        shareStatus: 0, thumbnail: "", isApprovedBestFriends: false,
        fmBrand: "",
        fmCategory: "",
        fmModelNo: "",
        fmProductName: "",
        fmPurchasePrice: 0,
        fmSellingPrice: 0,
        fmId: "",
        fleaMarket: {
            _id: "",
            createdAt: new Date(),
            end: new Date(),
            openYN: "",
            start: new Date(),
            title: "",
            usage: "",
            workplace: ""
        },
        fileNameList: [],
        fileUrlList: [],
        files: []
        // departmentList: [],
        // clubList: [],
    });

    const [selectedClub, setSelectedClub] = useState<Club>(initClub);
    const [selectedDepartment, setSelectedDepartment] = useState<Department>(initDepartment);

    let {id, workplace, no, page} = common.getQuery();
    let menu: MenuInterface = useMemo(() => common.getMenuObject(id), [id]);
    const navigate = useNavigate();
    const QuillRef: any = useRef<ReactQuill>();


    const fmCategoryRef: any = useRef();
    const fmProductNameRef: any = useRef();
    const fmBrandRef: any = useRef();
    const fmModelNoRef: any = useRef();
    const fmPurchasePriceRef: any = useRef();
    const fmSellingPriceRef: any = useRef();

    useEffect(() => {
        axios.get(`${constance.api.getPostView}?id=${id}&no=${no}&workplace=${workplace}`).then(value => {
            console.log(value);
            let post: PostInterface = value.data.post;
            // common.getMenuData(menu, setState, state);
            if (menu.id == config.departmentId) {
                setSelectedDepartment({
                    ...post.department,
                })
            } else if (menu.id == config.clubId) {
                setSelectedClub({
                    ...post.club,
                })
            } else if (menu.id == 'fleaMarket') {
                fmProductNameRef.current.value = post.fmProductName;
                fmBrandRef.current.value = post.fmBrand;
                fmModelNoRef.current.value = post.fmModelNo;
                fmPurchasePriceRef.current.value = post.fmPurchasePrice;
                fmSellingPriceRef.current.value = post.fmSellingPrice;
            }



            if (post.fileUrlList && post.fileUrlList.length > 0) {
                Promise.all(
                    post.fileUrlList.map((value) => urlToFile(value))
                ).then((files) => {
                    console.log('File 객체 배열:', files);
                    let fileList: File[] = [];
                    let index = 0;
                    for (let file of files) {
                        fileList.push(changeFileName(file, post.fileNameList[index]));
                        index++
                    }
                    setState({
                        ...state,
                        ...post,
                        files: fileList
                    });
                }).catch((error) => {
                    console.error('파일 변환 중 오류 발생:', error);
                    setState({
                        ...state,
                        ...post,
                    });
                });
            } else {
                setState({
                    ...state,
                    ...post,
                });
            }

        }).catch(reason => {
            console.log(reason);
        });
    }, [no]);

    function changeFileName(file: File, newFileName: string) {
        return new File([file], newFileName, {type: file.type, lastModified: file.lastModified});
    }

    async function urlToFile(fileName: string) {
        // URL에서 Blob 객체 가져오기
        const response = await fetch(`/${fileName}`);
        const blob = await response.blob();

        // Blob 객체를 File 객체로 변환
        const file = new File([blob], fileName, {type: blob.type});

        return file;
    }

    function handleUpdatePost() {
        let contents: any = QuillRef.current.value;
        if (state.title == '') {
            common.alert('제목을 입력해주세요.', '', 'info');
            return;
        } else if (contents == '') {
            common.alert('내용을 입력해주세요.', '', 'info');
            return;
        } else if (menu.id == config.clubId && selectedClub._id == '') {
            common.alert('동호회를 선택해주세요.', '', 'info');
            return;
        } else {
            if (id == 'share') {
                let matchResult: any = contents.match(/(<img[^>]+src\s*=\s*[\"']?([^>\"']+)[\"']?[^>]*>)/i);
                if (matchResult == null) {
                    common.alert('나눔할 물건 이미지를 넣어주세요', '', 'info');
                    return;
                }
            }
        }

        const formData = new FormData();
        for (let file of state.files) {
            const encodedFileName = encodeURIComponent(file.name);
            formData.append('files', file, encodedFileName);
        }

        let values: any = {
            id: id,
            no: no,
            workplace: state.workplace,
            contents: contents,
            title: state.title,
            amount: state.amount,
            shareStatus: state.shareStatus,
            club: selectedClub._id,
            department: selectedDepartment._id,
        }

        if (id === 'fleaMarket') {
            values.fmProductName = fmProductNameRef.current.value;
            values.fmBrand = fmBrandRef.current.value;
            values.fmModelNo = fmModelNoRef.current.value;
            values.fmPurchasePrice = fmPurchasePriceRef.current.value;
            values.fmSellingPrice = fmSellingPriceRef.current.value;
        }

        formData.append('values', JSON.stringify(values));


        axios({
            method: 'post',
            url: constance.api.updatePost,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then(value => {
            navigate(`${config.url.postView}?id=${id}&workplace=${workplace}&no=${no}`);
        }).catch(reason => {
            console.log(reason);
        });
    }

    function handleChangeTitle(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
        setState({
            ...state,
            title: e.target.value,
        });
    }

    function handleChangeWorkplace(workplace: number) {
        setState({
            ...state,
            workplace: workplace.toString()
        })
    }

    // 나눔 게시판 전용... 수량
    function changeAmount(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
        let value = Number(e.target.value);
        if (value < 1) return;
        setState({
            ...state,
            amount: value
        })
    }

    function changeShareStatus(e: React.ChangeEvent<HTMLInputElement>) {
        setState({
            ...state,
            shareStatus: Number(e.target.value)
        })
    }

    return (
        <>
            <Box sx={{display: 'flex', justifyContent: 'center', p: 1}}>
                <Stack sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center', mb: 2,
                }}>
                    {/* 사업장 선택이 있는 게시판일 경우 => 사업장 선택 버튼 생성 */}
                    <Box sx={{ 
                        width: 1,
                        display: config.workplaceBoardList.includes(menu.id) ? 'flex' : 'none',
                        justifyContent: 'flex-start', alignItems: 'center',
                        mt: 1,
                        mb: 1,
                        border: styles.border,
                        backgroundColor: 'var(--scc-surface)', borderRadius: 1,
                    }}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: 1,
                            p: 2,
                            width: 100,
                            minWidth: 100,
                            backgroundColor: '#696969'
                        }}>
                            <Typography sx={{color: 'white'}}> 사업장 선택 </Typography>
                        </Box>
                        <Divider orientation={'vertical'} sx={{mr: 2}}/>
                        <Box sx={{display: 'flex', flexWrap: 'wrap', pt: 1, pb: 1}}>
                            {
                                Object.keys(constance.workplace).map((key, index) => {
                                    if ((menu.id == config.clubId || menu.id == config.departmentId) && key == 'ALL') {
                                        return
                                    }
                                    const workplaceObject: any = constance.workplace;
                                    const _workplace: WorkplaceInterface = workplaceObject[key];
                                    return (
                                        <Button
                                            variant={state.workplace == _workplace.value.toString() ? 'contained' : 'outlined'}
                                            color={'neutral'}
                                            key={index}
                                            onClick={() => handleChangeWorkplace(_workplace.value)}
                                            sx={{
                                                m: 0.5,
                                                background: state.workplace === _workplace.value.toString() ? '#444444' : 'var(--scc-surface)'
                                            }}>
                                            {_workplace.name}
                                        </Button>
                                    );
                                })
                            }
                        </Box>

                    </Box>

                    {/* 나눔 게시판 전용*/}
                    {
                        menu.id === 'share' ?
                            <ShareBoardInputComponent menu={menu}
                                                      state={state}
                                                      changeShareStatus={changeShareStatus}
                                                      changeAmount={changeAmount}/> : ''
                    }

                    {/* 플리마켓 게시판 전용 */}
                    {
                        menu.id === 'fleaMarket' ?
                            <FleaMarketBoardInputComponent menu={menu}
                                                           state={state}
                                                           setState={setState}
                                                           refs={{
                                                               fmCategoryRef: fmCategoryRef,
                                                               fmProductNameRef: fmProductNameRef,
                                                               fmBrandRef: fmBrandRef,
                                                               fmModelNoRef: fmModelNoRef,
                                                               fmPurchasePriceRef: fmPurchasePriceRef,
                                                               fmSellingPriceRef: fmSellingPriceRef,
                                                           }}
                                                           changeShareStatus={changeShareStatus}
                                                           changeAmount={changeAmount}
                                                           isUpdatePage={true}
                            /> : ''
                    }

                    {/* 동호회 게시판 전용 Input */}
                    {
                        config.clubId === menu.id ?
                            <SelectClubComponent state={selectedClub}
                                                 setState={setSelectedClub}
                                                 workplace={state.workplace}/> : ''
                    }

                    {
                        config.departmentId === menu.id ?
                            <SelectDepartmentComponent state={selectedDepartment}
                                                       setState={setSelectedDepartment}
                                                       workplace={state.workplace}/> : ''
                    }


                    {/* 주제 */}
                    <Box sx={{
                        width: 1,
                    }}>
                        <TextField placeholder="제목을 입력해주세요."
                                   label=""
                                   value={state.title}
                                   variant="outlined"
                                   onChange={(e) => handleChangeTitle(e)}
                                   sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
                        />
                    </Box>
                    {/* 에디터 */}
                    <Stack sx={{
                        width: 1,
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        mt: 1,
                        background: 'var(--scc-surface)',
                        minHeight: 400,
                    }}>
                        <PostEditor readOnly={false}
                                    QuillRef={QuillRef}
                                    initContent={state.contents}
                        />
                        {/* 파일 업로드 */}
                        <FileUpdate state={state} setState={setState}/>
                    </Stack>


                    {/* 등록 */}
                    <Box sx={{width: 1, mt: 2, display: 'flex', justifyContent: 'flex-end'}}>
                        <Button variant={'contained'}
                                color={'primary'}
                                onClick={handleUpdatePost}
                        >
                            <Typography>수정</Typography>
                        </Button>
                    </Box>
                </Stack>
            </Box>
        </>
    );
}
